import fileUploadViewer from './FileUploadViewer';

export default angular.module('edge.platform.widgets.fileupload', [])
    .directive('gwFileUploadViewer', fileUploadViewer);